import { navigateToUrl } from 'single-spa';

export function redirectPaths(): void {
  const { hash = '', pathname, search = '' } = window.location;
  const { appEnv, enableDataLabRedirect, isWww, wwwUrl } = window.dcmfe.env;
  const isDevelopment = appEnv === 'development';

  // portfolio redirects
  if (pathname.startsWith('/profile')) {
    // redirect client-side links to /profile to www./portfolio unless local
    // development (where we just redirect to /portfolio)
    const newPathname = pathname.replace('/profile', '/portfolio');
    navigateToUrl(
      `${isWww || isDevelopment ? '' : wwwUrl}${newPathname}${hash}${search}`,
    );
  }

  if (pathname.startsWith('/portfolio') && !isWww && !isDevelopment) {
    // redirect client-side links to /portfolio to www./portfolio unless already
    // on www or local development
    navigateToUrl(`${wwwUrl}${pathname}${hash}${search}`);
  }

  // datalab redirects
  if (enableDataLabRedirect && pathname.startsWith('/workspace')) {
    // redirect client-side links to /workspace to www./datalab unless local
    // development (where we just redirect to /datalab)
    const newPathname = pathname.replace('/workspace', '/datalab');
    navigateToUrl(
      `${isWww || isDevelopment ? '' : wwwUrl}${newPathname}${hash}${search}`,
    );
  }

  if (
    enableDataLabRedirect &&
    pathname.startsWith('/datalab') &&
    !isWww &&
    !isDevelopment
  ) {
    // redirect client-side links to /datalab to www./datalab unless already
    // on www or local development
    navigateToUrl(`${wwwUrl}${pathname}${hash}${search}`);
  }
}
